<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormCartaDeBienvenida" role="form" method="post" autocomplete="off" onSubmit="return false">	
                    <div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <label for="idioma">Idioma:</label>
                            <select :disabled="DisableIdiomas" class="form-control form-select" v-model="objCartaDeBienvenida.Idioma">
                                <option value="">Seleccione una opción</option>
                                <option v-for="(item, index) in Idiomas" :key="index" :value="item.Lang">{{ item.Nombre }}</option>
                            </select>
                            <CValidation v-if="this.errorvalidacion.Idioma" :Mensaje="'*' + errorvalidacion.Idioma[0]"/>
                        </div>
                    </div>
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 quillEditorcol">
                            <label for="">Mensaje</label>
                            <quill-editor v-model="objCartaDeBienvenida.Mensaje" ref="quillEditorAC" :options="editorOption" class="quillEditor"></quill-editor>
						</div>
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <CValidation v-if="this.errorvalidacion.Mensaje" :Mensaje="'*' + errorvalidacion.Mensaje[0]"/>
                        </div>
					</div>
                    
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

import Configs from '@/helpers/VarConfig.js';

export default {
    name: 'FormCartaDeBienvenida',
    props: ['poBtnSave', 'pTipo'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCartaDeBienvenida: {
				IdCartaBienvenida: 0,
				Mensaje: '',
				IdEmpresa: 0,
				IdSucursal: 0,
                Idioma:'',
                TipoCarta:'',
            },
            DisableIdiomas: false,
            Idiomas:[
                {
                    Lang:'ES',
                    Nombre:'Español'
                },
                {
                    Lang:'EN',
                    Nombre:'Inglés'
                }
            ],
            IdiomasDisponibles:[],
            editorOption: {
                placeholder: 'Escribir Mensaje',
                theme:       'snow',
                modules: {
                    toolbar: {
                        container: Configs.configTolbarOptions, // opciones de barra de herramientas
                    }
                }
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objCartaDeBienvenida.IdCartaBienvenida == 0) {
				await this.$http.post(
					'cartasDeBienvenida',this.objCartaDeBienvenida
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'cartasDeBienvenida/'+this.objCartaDeBienvenida.IdCartaBienvenida,
					this.objCartaDeBienvenida
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "cartasDeBienvenida/"+this.objCartaDeBienvenida.IdCartaBienvenida
            ).then((res) => {
                this.objCartaDeBienvenida   = res.data.data;
                this.GetIdiomasPermitidos();
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objCartaDeBienvenida = {
				IdCartaBienvenida: 0,
				Mensaje: '',
				IdEmpresa: 0,
				IdSucursal: 0,
                Idioma:'',
                TipoCarta:''
				
            }
            this.IdiomasDisponibles=[],
            this.errorvalidacion = [];
        },
        ActualizarComboIdiomas(){
            this.Idiomas = this.Idiomas.filter(lang => {
                let match = this.IdiomasDisponibles.find(langAvb => lang.Lang==langAvb.idioma);
                if(match.idioma === this.objCartaDeBienvenida.Idioma) return true;
                return match.permite;
            });
            if(this.objCartaDeBienvenida.IdCartaBienvenida && this.Idiomas.length==1){
                this.DisableIdiomas = true;
            } else{
                this.DisableIdiomas = false;
            }
        },
        GetIdiomasPermitidos(){
            this.$http.get(
                "idiomasPermitidos", {params:{
                    TipoCarta:this.objCartaDeBienvenida.TipoCarta,
                }}
            ).then((res) => {
               this.IdiomasDisponibles = res.data.data;
            }).finally(()=>{
                this.ActualizarComboIdiomas();
                this.ConfigLoad.ShowLoader = false;
            });
        }
    },
    created() {
		this.poBtnSave.Toast = 0;
        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
            this.objCartaDeBienvenida.TipoCarta = this.pTipo;

            if (Id!='') 
            {
                this.objCartaDeBienvenida.IdCartaBienvenida = Id;
                this.Recuperar();
            }
            else
            {
                this.GetIdiomasPermitidos();
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
